import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { Form } from "ctia-react-bootstrap-v4";
import { LoaderButton, IconLabel } from "ctia-ui";
import { Modal, Button } from "react-bootstrap";
import { validateOrgFormASC } from "helpers/ServiceCenterHelper";
import { scrollTo } from "helpers/AppHelper";
import ErrorForm from "components/form/ErrorForm";
import AddServiceCenterForm from "containers/ControlPanel/Orgs/ServiceCenter/AddServiceCenterForm";
import { clearCountryState } from "actions/countries";
import { addCompanyASC } from "actions/asc";

const formId = "add-center-form";

const AddServiceCenterModal = ({
  show,
  modalHandler,
  clearCountryState,
  addCompanyASC,
  countries
}) => {
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const formRef = useRef(null);

  const renderSubmitButton = () => {
    return (
      <span className="icon-left-offset">
        <LoaderButton
          bsStyle="success"
          bsSize="small"
          text={<IconLabel label="Save" awesomeIcon="check" />}
          onClick={() => {
            setLoading(true);

            addCompanyASC(formId)
              .then(() => {
                setLoading(false);
                modalHandler();
                clearCountryState();

                // clean up the form
                formRef.current.reset();
                setValidated(false);
              })
              .catch(err => {
                setLoading(false);
                setErrorMessage(err);
                scrollTo(formId);
              });
          }}
          disabled={!validated}
          isLoading={loading}
        />
      </span>
    );
  };

  const onFormChange = event => {
    const form = event.currentTarget;

    if (form.checkValidity() === false || !validateOrgFormASC(form)) {
      return setValidated(false);
    }

    setValidated(true);
  };

  return (
    <Modal show={show}>
      <Modal.Header closeButton onHide={modalHandler}>
        <Modal.Title>Add Service Center</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          noValidate
          validated={validated}
          id={formId}
          className="ctia-form"
          onChange={onFormChange}
          ref={formRef}
        >
          <ErrorForm errors={errorMessage} />
          <AddServiceCenterForm />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {renderSubmitButton()}
        <Button onClick={modalHandler} className="agr-close-btn">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

function mapStateToProps({ countries }) {
  return { countries };
}

export default connect(mapStateToProps, {
  clearCountryState,
  addCompanyASC
})(AddServiceCenterModal);
